import { TrendingUp } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { MarginsPage } from './pages/MarginsPage'

/**
 * Margins — M9 DataView with group-by chips + Summary view.
 *
 * Spacious density + expanded filter rail per spec §9.3. No sidebar
 * badge — the margin endpoint is expensive to poll. Replaces
 * reports.siliconesplus.com/margins.
 */
export default defineModule({
  id: 'margins',
  name: 'Margins',
  shortName: 'Margins',
  icon: TrendingUp,
  navSection: 'sales',
  navOrder: 20,
  urlNamespace: '/margins',
  routes: [{ path: '/', element: MarginsPage, label: 'Margins' }],
  permissions: ['admin', 'sales', 'finance'],
  densityDefault: 'spacious',
  filterRailDefault: 'expanded',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g m',

  commandPaletteEntries: [
    {
      label: 'Go to Margins',
      keywords: ['margin', 'cogs', 'revenue', 'profit'],
      path: '/',
      group: 'modules',
      shortcut: 'g m',
    },
  ],

  deepLinkHandlers: [
    {
      entity: 'product',
      label: 'View margins for this product',
      buildPath: (productId) => `/?product=${productId}`,
    },
    {
      entity: 'customer',
      label: 'View margins for this customer',
      buildPath: (customerId) => `/?customer=${customerId}`,
    },
  ],
})
